import { render, staticRenderFns } from "./SbolLanding.vue?vue&type=template&id=6e7fed5e&scoped=true&"
import script from "./SbolLanding.vue?vue&type=script&lang=js&"
export * from "./SbolLanding.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolLanding.vue?vue&type=style&index=0&id=6e7fed5e&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6e7fed5e",
  null
  ,true
)

export default component.exports